/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.9",
  "buildId": "20260715-1450-b5bb29d",
  "builtAt": "2026-07-15T09:23:32.151Z"
});
